import * as Api from '@Api/index';
import { BackendError } from '@Common/errors';

import type { ApiResponse } from '@Types/Api';
import type { IApiRelatedProducts } from '@Types/RelatedProducts';

class RelatedProducts {
  private URL = '/backend/shop-product';

  async getAll(id: number) {
    const params = new URLSearchParams({ shopProductId: id.toString() });
    const url = `${this.URL}/get-related-products${
      params.toString() ? `?${params.toString()}` : ''
    }`;
    const response = await Api.queryProxi<ApiResponse<IApiRelatedProducts>>(url);

    if (!response.ok) throw new BackendError(url, response);

    return response.data;
  }
}

export const relatedProducts = new RelatedProducts();
